import { BillingCycle } from "../components/showPurchaseOrder/GeneratePO";
import { PaymentTerm } from "./ConsultantMast";
import { IClientCompanyDropdown } from "./IDropdown";

export enum POStatus {
  To_Join = 1,
  Joined = 2,
  Fizzled = 3,
  Ended = 4,
}

export interface IPurchaseOrder {
  pO_ID?: number;
  req_ID?: number;
  recruiter_ID?: number;
  sales_ID?: number;
  salesmanager?: string;
  user_Name?: string;
  prime_Vendor?: number;
  consultant_ID?: number;
  consultant_Name?: string;
  bRate?: number | null;
  sRate?: number | null;
  mRate?: number;
  consultant_Employeer_Sub_Vendor?: number;
  // sub_Vendor_Company?: string,
  sub_Vendor_Contact_Person?: string;
  sub_Vendor_Contact_Person_Email?: string;
  sub_Vendor_Contact_Person_Phone?: string;
  sub_Vendor_Contact_Person_CellNo?: string;
  sub_Vendor_Contact_Person_Ext?: string;
  prime_Vendor_Billing_Cycle?: BillingCycle;
  prime_Vendor_Payment_Term?: PaymentTerm;
  sub_Vendor_Billing_Cycle?: BillingCycle;
  sub_Vendor_Payment_Term?: PaymentTerm;
  project_Client_Name?: string;
  project_Name?: string;
  pM_Name?: string;
  pM_Email?: string;
  phone?: string;
  ext?: string;
  project_Start_Date?: Date;
  project_Start_Date1?: string;
  project_End_Date?: Date;
  project_End_Date1?: string;
  createdon?: Date;
  pO_Status?: POStatus;
  pO_Status_Name?: string;
  exp_End_Date?: Date;
  sub_Vendor_ID?: number;
  branch_Name?: string;
  brancPer?: number;
  headOffPer?: number;
  pO_Date?: Date;
  tentitive_Start_Date?: Date;
  fizzelReason?: string;
  req_Job_Title?: string;
  req_Duration?: string;
  city_Name?: string;
  state_Name?: string;
  salesBranch?: string;
  consultant_Email_id?: string;
  consultant_Job_Title?: string;
  consultant_Cell_No?: string;
  consultant_Home_No?: string;
  visa_Name?: string;
  vendor_Company_Name?: string;
  pO_Sub_Vendor_Company?: string;
  contact_Person_EmailID?: string;
  contact_Person_Name?: string;
  salesCompanyName?: string;
  company_Name_Sales?: string;
  recruiterBranch?: string;
  recruiterBranchID?: number;
  salesBranchID?: number;
  company_Name_Recruiter?: string;
  recruiterCompany?: string;
  req_CategoryName?: string;
  dollerRate?: any;
  pV_Referal?: boolean;
  sV_Referals?: boolean;
  salesBranchPer?: number;
  recBranchPer?: number;
  homeBranchPerA?: number;
  homeBranchPerB?: number;
  both?: boolean;
  sub_Vendor_Company?: IClientCompanyDropdown;
  req_Category?: number;
  consultant_Legal_Detail_Id?: number;
  consultant_Legal_Name?: string;
  consultant_Legal_Email?: string;
  consultant_Legal_Contact?: string;
  is_W2?: boolean;
  w2_Percentage?: number;
  w2_Doller_Rate?: number;
  w2_Referral_Rate?: number;
  is_Discount?: boolean;
  discount_Percentage?: number;
  company_ID_Sales?: number;
  company_ID_Recruiter?: number;
  changeDirect?: boolean;
  salesBranchPercentage?: number;
  recruiterBranchPercentage?: number;
  timesheet_Week_Start_Day?: number;
  sales_Team_Name?: string | null;
  recruiter_Team_Name?: string | null;
  parent_PO_ID?: number | null,
  tasks_Count?: number,
  marketing_Availability?: boolean
}
